module.exports = __webpack_public_path__ + "img/sintomas em ferimento de colheita.52c26c12.webp";